import {
  Component,
  ViewChild,
  ViewContainerRef,
  HostListener,
  ElementRef,
  ChangeDetectionStrategy,
  AfterViewInit
} from '@angular/core';
import { Subject } from 'rxjs';
import { ModalRef } from '../../services/modal/modal-ref';

@Component({
  selector: 'app-modal-container',
  standalone: true,
  template: `
    <ng-template #modalContent></ng-template>
  `
})
export class ModalContainerComponent implements AfterViewInit {
  @ViewChild('modalContent', { read: ViewContainerRef }) contentRef!: ViewContainerRef;

  readonly ready$ = new Subject<void>();

  modalRef!: ModalRef;

  constructor(private _elementRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.ready$.next();
    this.ready$.complete();
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (!this.modalRef?.disableClose) {
      this.modalRef?.close();
    }
  }
}
